import { render, staticRenderFns } from "./TrainingWatch.vue?vue&type=template&id=bdb581c8"
import script from "./TrainingWatch.vue?vue&type=script&lang=js"
export * from "./TrainingWatch.vue?vue&type=script&lang=js"
import style0 from "./TrainingWatch.vue?vue&type=style&index=0&id=bdb581c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports